import { env } from 'utils/env';

export const wp = {
	lotsa: env.APP_LOTSA_WP_URL || 'https://lotsahelpinghands.com',
	mcc: env.APP_MCC_WP_URL || 'https://mccdi.wpengine.com',
	mcc2: env.APP_MCC2_WP_URL || 'https://mycancercircle.wpengine.com',
	alsa: env.APP_ALSA_WP_URL || 'https://alsadi.wpengine.com',
	aicaf: env.APP_AICAF_WP_URL || 'https://webflow.aicafsacredcircle.com',
};
